import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "font-mBold main-m" }
const _hoisted_2 = {
  key: 3,
  class: "mleft-02 row"
}
const _hoisted_3 = {
  key: 4,
  class: "col gap-30 w-full mtop-20"
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = {
  class: "row",
  style: {"width":"7rem"}
}
const _hoisted_6 = {
  key: 0,
  class: "mtop-01 w-full"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "row",
  style: {"width":"7rem"}
}
const _hoisted_9 = {
  key: 0,
  class: "w-full"
}
const _hoisted_10 = {
  class: "row",
  style: {"width":"7rem"}
}
const _hoisted_11 = { class: "mtop-01 w-full" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = {
  class: "row",
  style: {"width":"7rem"}
}

import { ref, computed, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import gen from "@/functions/general.js"
import { taskModuleIconMap, getTaskBoxIcon, taskModuleTerms } from "@/functions/office"
import officeapi from "@/api/officeapi"
import { useAppUserStore } from '@/stores/appUser'
import { ApiError } from '@/models/share.model'
import { toastError, toastSuccess } from '@/utils/toast-utils'
import { useI18n } from 'vue-i18n'
import { useToast } from 'primevue'
import { TaskApi, TaskBoxesResponse, TaskBoxesParticipantsResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config'
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'editTaskBoxCustom',
  props: {
    taskBox: {},
    taskBoxParticipant: {},
    isAssignee: { type: Boolean, default: true }
  },
  emits: ['close', 'afterDeactivateTaskBox', 'refreshParticipant'],
  setup(__props: any, { emit: __emit }) {

const appUserStore = useAppUserStore()
const toast = useToast();
const { t } = useI18n();

const emits = __emit;
const props =  __props;

const taskApi = new TaskApi(medServerApiConfig);

const focusRef = ref(null);
const dropd = ref("");

const currTaskBoxModuleType = ref(props.taskBox?.taskBoxModuleType || 'None');
const taskBoxTitleInput = ref(props.taskBox?.taskBoxTitle || "");
const isTaskBoxTitleUpdated = ref(false);
const isTaskBoxModuleTypeUpdated = ref(false);
const canBeDeactivated = ref<boolean>(false);

function setTaskModuleType(taskModuleType: string) {
  isTaskBoxModuleTypeUpdated.value = true
  currTaskBoxModuleType.value = taskModuleType
  dropd.value = ""
  focus()
}

function setTaskBoxTitle() {
  isTaskBoxTitleUpdated.value = true
}

async function updateTaskModuleType() {
  if (!props.taskBox) return;
  if (isTaskBoxModuleTypeUpdated.value === false) return;
  //Update
  const taskBoxId = props.taskBox.taskBoxId
  const taskBoxModuleType = currTaskBoxModuleType.value
  await officeapi.updateTaskBoxModuleType(taskBoxId, taskBoxModuleType)
}

async function updateTaskBoxTitle() {
  if (!props.taskBox) return;
  if (isTaskBoxTitleUpdated.value === false) return;
  //Update
  const taskBoxId = props.taskBox.taskBoxId
  const taskBoxTitle = taskBoxTitleInput.value
  await officeapi.updateTaskBoxTitle(taskBoxId, taskBoxTitle)
}

async function updateParticipants() {
  if (!props.taskBox) return;

  const taskBoxId = props.taskBox.taskBoxId
  const updatePromises = uniquePersons.value
    .filter(pwr => pwr.initialStatus !== pwr.status)
    .map(async (pwr) => {
      const appUserId = pwr.appUserId
      switch(pwr.status) {
        case 'Assignee':
          await officeapi.setTaskBoxParticipant(appUserId, taskBoxId, true)
          break
        case 'Observer':
          await officeapi.setTaskBoxParticipant(appUserId, taskBoxId, false)
          break
        case 'None':
          await officeapi.deleteTaskBoxParticipant(appUserId, taskBoxId)
          break
      }
    })
  await Promise.all(updatePromises)
}

const pwrCreator = computed(() => {
  if (!props.taskBoxParticipant) return null
  return props.taskBoxParticipant.pwrTaskBoxCreator;
})

function isPwrCreator(pwr) {
  if (!pwrCreator.value) return false
  return pwrCreator.value.personWithRoleId === pwr.personWithRoleId
}

const isAppUserPwrCreator = computed(() => {
  const pwrAppUser = appUserStore.currentHealthGroupMembership.pwr
  return isPwrCreator(pwrAppUser)
})


const setCanBeDeactivated = async () => {
  if (!appUserStore.taskList) return false;
  if (props.taskBox.taskBoxChannelType !== 'None') return false;

  canBeDeactivated.value = await taskApi.countTask({taskBoxUuid: props.taskBox.taskBoxId, futureTasks: true, withSettled:false }) === 0;
}

//TaskBox Participants
const assigneePwrIds = computed(() => {
  if (!props.taskBoxParticipant) return []
  return props.taskBoxParticipant.pwrParticipants
    .filter(pwr => pwr.isAssignee)
    .map(pwr => pwr.personWithRoleId)
})

const nonAssigneePwrIds = computed(() => {
  if (!props.taskBoxParticipant) return []
  return props.taskBoxParticipant.pwrParticipants
    .filter(pwr => !pwr.isAssignee)
    .map(pwr => pwr.personWithRoleId)
})


function inputLineEnter() {
  if (props.taskBox) return;
  createNewTaskBox();
}

async function createNewTaskBox() {
  if (props.taskBox) return;

  const taskBoxTitle = taskBoxTitleInput.value;
  const taskBoxModuleType = currTaskBoxModuleType.value;

  await officeapi.createTaskBox(taskBoxTitle, taskBoxModuleType, props.isAssignee).then(async () => {
    await appUserStore.setTaskBoxList();

    toastSuccess(toast, {
        summary: t('common.toast.success.add'),
        detail:  t('task.group.message.success.add')
    });

    emits("close");
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
    });
  }); 
}

async function deactivateTaskBox() {
  if (!props.taskBox) return;
  const taskBoxId = props.taskBox.taskBoxId
  await officeapi.deactivateTaskBox(taskBoxId).then(async () => {
    emits("afterDeactivateTaskBox");
    toastSuccess(toast, {
        summary: t('common.toast.success.deactivate'),
        detail:  t('task.group.message.success.deactivate')
    });
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
    });
  }); 
}
function getAssigneeStatus(pwr) {
  if (assigneePwrIds.value.includes(pwr.personWithRoleId)) return 'Assignee'
  if (nonAssigneePwrIds.value.includes(pwr.personWithRoleId)) return 'Observer'
  return "None"
}

function getPwrStatus(pwrMember) {
  const uniquePwr = uniquePersons.value.find(pwrUnique => pwrMember.personWithRoleId === pwrUnique.personWithRoleId)
  return uniquePwr.status
}

function getPwrStatusTerm(pwrMember) {
  const status = getPwrStatus(pwrMember)
  return getStatusTerm(status)
}

function getStatusTerm(status) {
  const terms = {
    'Assignee' : 'Exécutant',
    'Observer' : 'Observateur',
    'None' : '∅',
  }
  return terms[status]
}

function setPwrStatus(pwrMember, newStatus) {
  const uniquePwr = uniquePersons.value.find(pwrUnique => pwrMember.personWithRoleId === pwrUnique.personWithRoleId);
  uniquePwr.status = newStatus;
  emits('refreshParticipant');
}

const uniquePersons = ref([])
function setUniquePersons() {
  if (!appUserStore.currentAppUserData) {
    uniquePersons.value = []
    return
  }
  let uniquePwrList = appUserStore.currentAppUserData.healthGroupMemberships
    .flatMap(healthGroupMembership => healthGroupMembership.healthGroupMembers.map(healthGroupMember => healthGroupMember.pwr))
    .filter((pwr, index, self) => index === self.findIndex(p => p.personWithRoleId === pwr.personWithRoleId))   //eliminate duplicates
    .map(pwr => gen.deepCopy(pwr))
  uniquePwrList.forEach(pwr => {
    pwr.initialStatus = getAssigneeStatus(pwr)
    pwr.status = pwr.initialStatus
  })
  uniquePersons.value = uniquePwrList
}

function focus() {
  nextTick(() => {
    if (!focusRef.value) return;
    focusRef.value.innerRef.focus();
  })
}

async function updateTaskBox(){
  if (!props.taskBox) return;
  //Update
  await updateTaskModuleType()
  await updateTaskBoxTitle()
  await updateParticipants()
  //Reload
  await appUserStore.setTaskBoxList()
}

watch(
  () => appUserStore.currentAppUserData,
  () => {
    setUniquePersons();
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  updateTaskBox()
});

onMounted(() => {
  focus();
  setCanBeDeactivated();
});

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_listGroup2 = _resolveComponent("listGroup2")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_switchGroup = _resolveComponent("switchGroup")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal w-maxC",
    onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
  }, [
    (!props.taskBox)
      ? (_openBlock(), _createBlock(_component_button_group, {
          key: 0,
          styles: "border-h pad-s",
          class: "mleft-auto psides-10",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (createNewTaskBox()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_item, {
              txt: _unref(t)('action.create'),
              styles: "font-mBold"
            }, null, 8, ["txt"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isAppUserPwrCreator.value && canBeDeactivated.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "row w-full",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (deactivateTaskBox()))
        }, [
          _createVNode(_component_button_group, {
            styles: "border-m pad-s",
            class: "mleft-auto psides-06"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('task.taskBoxDetail.deactivate')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    ((!props.taskBox || isAppUserPwrCreator.value) && _ctx.taskBox?.taskBoxChannelType !== 'Results')
      ? (_openBlock(), _createBlock(_component_inputBox, {
          key: 2,
          class: "row-top w-full h-full mtop-06"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropd).value = $event)),
              openOn: "addTaskBoxDirect"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", {
                  class: "bg-modal w-maxC",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taskModuleIconMap), (key, value, index) => {
                    return (_openBlock(), _createBlock(_component_listGroup2, {
                      key: index,
                      styles: "pad-m",
                      class: "w-full",
                      onClick: ($event: any) => (setTaskModuleType(value))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_item, { icon: key }, null, 8, ["icon"]),
                        _createVNode(_component_text_item, {
                          class: "mleft-04",
                          txt: _unref(taskModuleTerms)[value]
                        }, null, 8, ["txt"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, {
                  class: "mleft-02",
                  theme: "dropdown"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: _unref(taskModuleIconMap)[currTaskBoxModuleType.value],
                      styles: "main-m size-m"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _cache[10] || (_cache[10] = _createElementVNode("div", {
              class: "line-v h-full",
              style: {"height":"2rem"}
            }, null, -1)),
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: taskBoxTitleInput.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((taskBoxTitleInput).value = $event)),
              placeholder: "Titre ...",
              style: {"width":"22rem"},
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (setTaskBoxTitle())),
              onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (inputLineEnter()), ["exact","prevent"]), ["enter"]))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_svg_item, {
            icon: _unref(getTaskBoxIcon)(props.taskBox),
            styles: "main-h size-m"
          }, null, 8, ["icon"]),
          _createVNode(_component_text_item, {
            class: "mleft-06",
            txt: taskBoxTitleInput.value,
            styles: "font-mBold"
          }, null, 8, ["txt"])
        ])),
    (props.taskBox)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('task.taskBox.creator'),
                styles: "font-mBold main-l",
                style: {"margin-left":"auto"}
              }, null, 8, ["txt"])
            ]),
            (pwrCreator.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_text_item, {
                        txt: _unref(PersonService).formatName(pwrCreator.value.lastName, pwrCreator.value.firstName),
                        class: "mtop-02 mleft-auto"
                      }, null, 8, ["txt"])
                    ]),
                    (isAppUserPwrCreator.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_switchGroup, {
                            active: getPwrStatus(pwrCreator.value) === 'Assignee',
                            class: "mleft-08",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (setPwrStatus(pwrCreator.value, 'Assignee')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_text_item, {
                                txt: getStatusTerm('Assignee'),
                                class: _normalizeClass(getPwrStatus(pwrCreator.value) === 'Assignee' ? 'txt-white' : '')
                              }, null, 8, ["txt", "class"])
                            ]),
                            _: 1
                          }, 8, ["active"]),
                          (props.taskBox?.taskBoxChannelType === 'None')
                            ? (_openBlock(), _createBlock(_component_switchGroup, {
                                key: 0,
                                active: getPwrStatus(pwrCreator.value) === 'Observer',
                                class: "mleft-04",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (setPwrStatus(pwrCreator.value, 'Observer')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_text_item, {
                                    txt: getStatusTerm('Observer'),
                                    class: _normalizeClass(getPwrStatus(pwrCreator.value) === 'Observer' ? 'txt-white' : '')
                                  }, null, 8, ["txt", "class"])
                                ]),
                                _: 1
                              }, 8, ["active"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_text_item, {
                          key: 1,
                          txt: getPwrStatusTerm(pwrCreator.value),
                          styles: "font-m main-m",
                          class: "mtop-02 mleft-08"
                        }, null, 8, ["txt"]))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appUserStore).currentAppUserData.healthGroupMemberships, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item.healthGroupMembers.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_text_item, {
                        txt: item.instituteWithRole.instituteShortName,
                        styles: "font-mBold main-l",
                        style: {"margin-left":"auto"}
                      }, null, 8, ["txt"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.healthGroupMembers, (item2, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (!isPwrCreator(item2.pwr))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_component_text_item, {
                                    txt: item2.pwr.firstName,
                                    styles: "font-m main-h",
                                    style: {"margin-left":"auto"}
                                  }, null, 8, ["txt"])
                                ]),
                                (isAppUserPwrCreator.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_switchGroup, {
                                        active: getPwrStatus(item2.pwr) === 'Assignee',
                                        class: "mleft-08",
                                        onClick: ($event: any) => (setPwrStatus(item2.pwr, 'Assignee'))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            txt: getStatusTerm('Assignee'),
                                            styles: "font-m main-h",
                                            class: _normalizeClass(getPwrStatus(item2.pwr) === 'Assignee' ? 'txt-white' : '')
                                          }, null, 8, ["txt", "class"])
                                        ]),
                                        _: 2
                                      }, 1032, ["active", "onClick"]),
                                      _createVNode(_component_switchGroup, {
                                        active: getPwrStatus(item2.pwr) === 'Observer',
                                        class: "mleft-04",
                                        onClick: ($event: any) => (setPwrStatus(item2.pwr, 'Observer'))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            txt: getStatusTerm('Observer'),
                                            styles: "font-m main-h",
                                            class: _normalizeClass(getPwrStatus(item2.pwr) === 'Observer' ? 'txt-white' : '')
                                          }, null, 8, ["txt", "class"])
                                        ]),
                                        _: 2
                                      }, 1032, ["active", "onClick"]),
                                      _createVNode(_component_switchGroup, {
                                        active: getPwrStatus(item2.pwr) === 'None',
                                        class: "mleft-04",
                                        onClick: ($event: any) => (setPwrStatus(item2.pwr, 'None'))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_text_item, {
                                            txt: getStatusTerm('None'),
                                            styles: "font-m main-h",
                                            class: _normalizeClass(getPwrStatus(item2.pwr) === 'None' ? 'txt-white' : '')
                                          }, null, 8, ["txt", "class"])
                                        ]),
                                        _: 2
                                      }, 1032, ["active", "onClick"])
                                    ], 64))
                                  : (_openBlock(), _createBlock(_component_text_item, {
                                      key: 1,
                                      txt: getPwrStatusTerm(item2.pwr),
                                      styles: "font-m main-m",
                                      class: "mtop-02 mleft-08"
                                    }, null, 8, ["txt"]))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})